import OtpManager from "./OtpManager";
import CollapsableBox from "../collapsableBox/CollapsableBox";

export interface OtpManagerSettingsSectionProps {
    isInitiallyOpen?: boolean;
}

const OtpManagerSettingsSection = ({ isInitiallyOpen }: OtpManagerSettingsSectionProps) => {
    return (
        <CollapsableBox title="OTP Settings" isInitiallyOpen={isInitiallyOpen}>
            <OtpManager />
        </CollapsableBox>
    )
}

export default OtpManagerSettingsSection;